<template>
  <div>
    <HistoryInfoBoxes :detail="info">
      <template #box0>
        <v-row no-gutters>
          <v-col cols="3">{{ $t('sale.sale_ship-destdate') }}： </v-col>
          <v-col>{{ nullEmptyFormat(items.shipDate) }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3">{{ $t('ship.ship_arrival-date') }}： </v-col>
          <v-col>{{ nullEmptyFormat(items.arrivalDate) }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3"
            >{{ $t('storage.storage_storage-move-number') }}：
          </v-col>
          <v-col>{{ nullEmptyFormat(items.transaction.controlNumber) }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3">{{ $t('ship.ship_tracking-number') }}： </v-col>
          <v-col>{{ nullEmptyFormat(items.trackingNumber) }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3"
            >{{ $t('storage.storage_storage-move-reason') }}：
          </v-col>
          <v-col>{{ getStockMoveReason(items.storageMoveReasonId) }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3">{{ $t('common.input_remarks') }}： </v-col>
          <v-col
            >{{ items.storageMoveNote ? items.storageMoveNote.body : '' }}
          </v-col>
        </v-row>
      </template>
      <template #box1>
        <v-row no-gutters>
          <v-col class="mb-1 font-weight-bold nameText"
            >{{ nullEmptyFormat(items.destName) }}
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col
            >{{
              getDisplayPostalCode(
                getPostalCode(items.destPostalCode, items.destCountryId)
              )
            }}
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col
            >{{
              nullEmptyFormat(
                getRegionName(items.desCountryId, items.destRegionId)
              ) +
              nullEmptyFormat(items.destAddress1) +
              nullEmptyFormat(items.destAddress2)
            }}
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="2">{{ $t('common.input_phone-number') }}： </v-col>
          <v-col
            >{{
              nullEmptyFormat(
                getPhoneNumber(
                  items.destPhoneNumber,
                  items.destPhoneNumberCountryId
                )
              )
            }}
          </v-col>
        </v-row>
      </template>
    </HistoryInfoBoxes>
  </div>
</template>
<script>
import HistoryInfoBoxes from '@/components/items/Designs/HistoryInfoBoxes'
import {
  commonUtil,
  countryUtil,
  countryCallingCodeUtil,
  stockMoveUtil
} from '@/util'

export default {
  components: { HistoryInfoBoxes },
  props: {
    items: { default: {} }
  },
  data: () => ({
    info: []
  }),
  created() {
    this.info = this.createList()
  },
  methods: {
    createList() {
      const shipInfo = {
        ...this.interfaceObj,
        title: 'storage.storage_storage-move-info'
      }
      const destinationInfo = {
        ...this.interfaceObj,
        title: this.$t('common.input_recipient-info')
      }

      return [shipInfo, destinationInfo]
    },
    getCountryName(id) {
      const country = countryUtil.findCountryId(id)
      return country ? country.name : ''
    },
    getRegionName(countryId, regionId) {
      return countryUtil.getRegionInfo(countryId, regionId).label
    },
    getPhoneNumber(phone, callingCode) {
      return countryCallingCodeUtil.formatPhoneNumber(phone, callingCode)
    },
    getPostalCode(postalCode, countryId) {
      return commonUtil.formatPostalCode(postalCode, countryId)
    },
    getDisplayPostalCode(postalCode) {
      if (!postalCode) return ''
      return '〒' + postalCode
    },
    getStockMoveReason(id) {
      return stockMoveUtil.getStockMoveReasonById(id)?.name
    },
    nullEmptyFormat(str) {
      return commonUtil.nullEmptyFormat(str, '')
    }
  },
  computed: {}
}
</script>
<style lang="scss" scoped>
.nameText {
  font-size: 14px;
}
</style>
